<template>
    <div class="cards__container">
        <div class="cards__tariffs gap-3">
            <template v-for="template in tariffTemplates">
                <tariff-page-card
                    :template="template"
                    :active-ratio="activeRatio"
                    :active-percent="activePercent"
                    :user="user"
                    :user-tariff-id="userTariffId"
                    :is-demo="isDemo"
                    :locale="locale"
                    :details-title-id="detailsTitleId"
                    :term-relations="termRelations"
                />
            </template>
        </div>
    </div>
</template>

<script>
import {TariffTime} from "../constants/tariffTime";
import TariffPageCard from "./Card.vue";

export default {
    name: "TariffPageCards",
    props: {
        activeTermTabSlug: String,
        activePercent: Number,
        activeRatio: Number,
        tariffTemplates: Object,
        user: Object,
        userTariffId: Number,
        isDemo: Boolean,
        locale: String,
        termRelations: Object,
        detailsTitleId: {
            type: String,
            required: true
        }
    },
    components: {
        TariffPageCard
    }
}
</script>

<style scoped>
.cards__container > div {
    display: flex;
    overflow-x: auto;
    margin-bottom: 28px;
}
.cards__promo {
    justify-content: center;
}
.cards__tariffs {
    justify-content: space-between;
}
</style>
